exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---1kTuc {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .component---1kTuc h3 {\n    margin-left: 8px;\n    font-weight: 500;\n    font-size: 18px; }\n  .component---1kTuc .back-button---2_FbP {\n    border-radius: 20px;\n    background-color: #278bcb;\n    width: 30px;\n    height: 30px; }\n  .component---1kTuc .back-button---2_FbP svg {\n      margin-right: 2px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1kTuc",
	"back-button": "back-button---2_FbP"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/table-header/table-header.scss
// module id = V289
// module chunks = 1